// extracted by mini-css-extract-plugin
module.exports = {"container":"OrderContainerView_container__9-ORh","background":"OrderContainerView_background__3TjxR"};